import './Supplies.scss';
import Component from './Supplies.js';
export default Component;
